import { useCallback, useState } from 'react';
const createNewObject = ()=>({});
export function useForceUpdate() {
    const [, setValue] = useState(createNewObject);
    return useCallback(()=>{
        setValue(createNewObject());
    }, []);
}

//# sourceMappingURL=useForceUpdate.js.map